import React from 'react';

const mapTypeToColor = {
  success: 'rgba(45, 183, 45, 0.12)',
  info: 'rgba(3, 105, 161, 0.12)',
  warning: 'rgba(224, 114, 17, 0.12)',
  critical: 'rgba(220, 38, 38, 0.12)',
};

const Badge = ({ children, type, prefix }) => {
  return (
    <span
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        textAlign: 'center',
        gap: 4,
        padding: '0 6px',
        borderRadius: 4,
        color: 'rgba(23, 23, 23, 0.72)',
        backgroundColor: mapTypeToColor[type],
        fontSize: 12,
        height: 20,
      }}
    >
      {prefix}
      {children}
    </span>
  );
};

export default Badge;
